module.exports = __webpack_public_path__ + "static/media/toggle-drawer-icon.b200a373.png";